"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const categoriesData = [{
  id: 1,
  title: "Klasická erotická masáž (B2B)",
  description: "Tady jde o doteky po celém těle - pomalé, plynulé, uvolňující. Hraje se hodně s atmosférou a celkovým tempem. Masérka používá teplé oleje a nikam nespěchá. Svaly i mysl se uvolní postupně, bez tlaku na výkon. Smyslový zážitek je tady na prvním místě. Tenhle typ masáže je pro všechny. Klidně pro ty, kdo s erotickými masážemi teprve začínají a hledají přirozený bezpečný způsob jak to zkusit.",
  services: [{
    duration: "30min",
    maserka: "1 maserka",
    price: "1 500 Kč"
  }, {
    duration: "30min",
    maserka: "2 maserky",
    price: "2 500 Kč"
  }, {
    duration: "45min",
    maserka: "1 maserka",
    price: "1 700 Kč"
  }, {
    duration: "45min",
    maserka: "2 maserky",
    price: "2 700 Kč"
  }, {
    duration: "60min",
    maserka: "1 maserka",
    price: "2 300 Kč"
  }, {
    duration: "60min",
    maserka: "2 maserky",
    price: "4 100 Kč"
  }, {
    duration: "90min",
    maserka: "1 maserka",
    price: "2 900 Kč"
  }, {
    duration: "90min",
    maserka: "2 maserky",
    price: "4 700 Kč"
  }, {
    duration: "120min",
    maserka: "1 maserka",
    price: "3 600 Kč"
  }, {
    duration: "120min",
    maserka: "2 maserky",
    price: "5 400 Kč"
  }],
  idClassName: "text-card-foreground gap-6 relative border-primary/20 backdrop-blur-md !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660511/img/dark_sensual_woman1.png)] bg-cover bg-center before:absolute before:inset-0 before:bg-black/80 before:bg-linear-to-t before:from-black before:to-transparent before:rounded-2xl rounded-2xl p-8 flex flex-col h-full transition-all duration-500 hover:border-primary/40 group"
}, {
  id: 2,
  title: "Masáž lingamu",
  description: "Masáž lingamu patří mezi ty nejpropracovanější erotické masáže, které u nás najdete. Celá je o pomalosti, dechu, doteku a skutečném uvolnění. Tady nejde o žádný rychlý zážitek nebo automatický rituál. Naopak - jde o proces, který pomáhá vypnout hlavu, zapomenout na stres i věčné honění se za výkonem. Muži díky ní znovu cítí svoje tělo, dostanou klid do duše a zažijí relaxaci, která jde opravdu do hloubky.",
  services: [{
    duration: "30min",
    maserka: "1 maserka",
    price: "2 000 Kč"
  }, {
    duration: "30min",
    maserka: "2 maserky",
    price: "3 000 Kč"
  }, {
    duration: "60min",
    maserka: "1 maserka",
    price: "2 500 Kč"
  }, {
    duration: "60min",
    maserka: "2 maserky",
    price: "4 000 Kč"
  }, {
    duration: "90min",
    maserka: "1 maserka",
    price: "3 400 Kč"
  }, {
    duration: "90min",
    maserka: "2 maserky",
    price: "5 000 Kč"
  }],
  idClassName: "text-card-foreground gap-6 relative border-primary/20 backdrop-blur-md !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660511/img/dark_sensual_woman2.png)] bg-cover bg-center before:absolute before:inset-0 before:bg-black/80 before:bg-linear-to-t before:from-black before:to-transparent before:rounded-2xl rounded-2xl p-8 flex flex-col h-full transition-all duration-500 hover:border-primary/40 group"
}, {
  id: 3,
  title: "Masáž se dvěma masérkami",
  description: "Hlavně samotná přítomnost dvou masérek. Jejich pohyby se dokonale doplňují, vytvářejí rytmus, který tělem projíždí vlnu za vlnou. Doteky přicházejí z různých směrů, tělo najednou vnímá mnohem víc a mysl se rychleji dostává do hluboké relaxace. Každý pohyb je promyšlený, ale přesto působí přirozeně a spontánně - masérky se vždycky ladí na vaše aktuální potřeby.",
  services: [{
    duration: "15min",
    maserka: "2 maserky",
    price: "1 800 Kč"
  }, {
    duration: "30min",
    maserka: "2 maserky",
    price: "2 500 Kč"
  }, {
    duration: "45min",
    maserka: "2 maserky",
    price: "2 700 Kč"
  }, {
    duration: "60min",
    maserka: "2 maserky",
    price: "3 400 Kč"
  }, {
    duration: "90min",
    maserka: "2 maserky",
    price: "4 700 Kč"
  }],
  idClassName: "text-card-foreground gap-6 relative border-primary/20 backdrop-blur-md !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660511/img/dark_sensual_woman3.png)] bg-cover bg-center before:absolute before:inset-0 before:bg-black/80 before:bg-linear-to-t before:from-black before:to-transparent before:rounded-2xl rounded-2xl p-8 flex flex-col h-full transition-all duration-500 hover:border-primary/40 group"
}, {
  id: 4,
  title: "Erotická masáž pro páry",
  description: "Pro koho se tahle masáž vlastně hodí? Je to jedno, jestli jste spolu krátce nebo už roky. Nové páry získají další důvod k důvěře a sblížení, dlouhodobé vztahy zase osvěží svůj intimní život. Tady nejde o žádné výkony nebo očekávání - hlavní je společný prožitek a uvolnění. Nemusíte mít žádné zkušenosti s erotickými masážemi. Všechno plyne v tempu, které vám je příjemné.",
  services: [{
    duration: "60min",
    maserka: "1 maserka",
    price: "3 200 Kč"
  }, {
    duration: "60min",
    maserka: "2 maserky",
    price: "4 900 Kč"
  }, {
    duration: "90min",
    maserka: "1 maserka",
    price: "4 200 Kč"
  }, {
    duration: "90min",
    maserka: "2 maserky",
    price: "6 400 Kč"
  }, {
    duration: "120min",
    maserka: "1 maserka",
    price: "5 200 Kč"
  }, {
    duration: "120min",
    maserka: "2 maserky",
    price: "7 900 Kč"
  }],
  idClassName: "text-card-foreground gap-6 relative border-primary/20 backdrop-blur-md !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660511/img/sensual_couple_massage_ritual.png)] bg-cover bg-center before:absolute before:inset-0 before:bg-black/80 before:bg-linear-to-t before:from-black before:to-transparent before:rounded-2xl rounded-2xl p-8 flex flex-col h-full transition-all duration-500 hover:border-primary/40 group"
}];
export default function MainServices() {
  return <section data-section-id="239763" id="menu-masáží" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] -z-10" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] -z-10" />

      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-serif tracking-tight">Menu našich masáží</h2>
          <p className="text-lg text-muted-foreground font-sans">
            Objevte svět, kde se čas zastaví a vaše smysly ožijí. Vyberte si z naší nabídky exkluzivních masáží navržených pro vaše maximální potěšení.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {categoriesData.map((category, i) => <Card key={category.id} data-index={i} className={`${category.idClassName || ""} relative border-primary/20 backdrop-blur-md rounded-2xl p-8 flex flex-col h-full transition-all duration-500 hover:border-primary/40 group overflow-hidden`}>
              <div className="relative z-10 mb-8 h-32">
                <h3 className="font-serif text-primary mb-2 tracking-wide !text-center !text-2xl">
                  {category.title}
                </h3>
                <p className="text-sm text-muted-foreground font-sans italic !text-center ![padding:15px_0px_0px_0px]">
                  {category.description}
                </p>
              </div>

              <div className="relative z-10 flex-1 space-y-6 ![margin:20px_0px_0px_0px]">
                <div className="space-y-4 ![margin:320px_0px_0px_0px]">
                  {category.services ? category.services.map((s, idx) => <React.Fragment key={idx}>
                        <div className="flex justify-between items-start gap-4">
                          <span className="text-primary font-sans text-base leading-tight">
                            {s.duration} – {s.maserka}
                          </span>
                          <span className="text-[hsl(330,45%,70%)] font-sans font-bold whitespace-nowrap ![margin:0px_0px_10px_0px]">
                            {s.price}
                          </span>
                        </div>
                        {idx < category.services.length - 1 && <Separator className="bg-muted/20" />}
                      </React.Fragment>) : <>
                      <div className="flex justify-between items-end gap-4 ![margin:60px_0px_16px_0px]">
                        <span className="text-primary font-sans text-base leading-tight">{(category as any).service1}</span>
                        <span className="text-[hsl(330,45%,70%)] font-sans font-bold whitespace-nowrap">{(category as any).price1}</span>
                      </div>
                      <Separator className="bg-muted/20" />
                      
                      <div className="flex justify-between items-end gap-4">
                        <span className="text-primary font-sans text-base leading-tight">{(category as any).service2}</span>
                        <span className="text-[hsl(330,45%,70%)] font-sans font-bold whitespace-nowrap">{(category as any).price2}</span>
                      </div>
                      <Separator className="bg-muted/20" />

                      <div className="flex justify-between items-end gap-4">
                        <span className="text-primary font-sans text-base leading-tight">{(category as any).service3}</span>
                        <span className="text-[hsl(330,45%,70%)] font-sans font-bold whitespace-nowrap">{(category as any).price3}</span>
                      </div>
                      <Separator className="bg-muted/20" />

                      <div className="flex justify-between items-end gap-4">
                        <span className="text-primary font-sans text-base leading-tight">{(category as any).service4}</span>
                        <span className="text-[hsl(330,45%,70%)] font-sans font-bold whitespace-nowrap">{(category as any).price4}</span>
                      </div>
                    </>}
                </div>
              </div>

              <div className="relative z-10 mt-10">
                <Button asChild className="w-full rounded-full border border-primary/50 bg-transparent text-foreground hover:bg-primary/10 hover:scale-105 hover:shadow-[0_0_20px_rgba(217,140,178,0.5)] transition-all duration-300 font-sans uppercase tracking-widest text-xs py-6">
                  <Link to="/ContactPage">
                    Rezervovat
                  </Link>
                </Button>
              </div>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground font-sans text-sm italic">
            * Všechny ceny jsou konečné. Pro individuální požadavky nás neváhejte kontaktovat.
          </p>
        </div>
      </div>
    </section>;
}